import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import FundLanding from "./pages/FundLanding";
import Dashboard from "./pages/Dashboard";
import CompanyDeepDive from "./pages/CompanyDeepDive";
import TargetDueDiligence from "./pages/TargetDueDiligence";
import Login from "./pages/Login";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/fund/khazanah" replace />} />
      <Route path="/fund/:slug" element={<FundLanding />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/company/:id" element={<CompanyDeepDive />} />
      <Route path="/target" element={<TargetDueDiligence />} />
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<Navigate to="/fund/khazanah" replace />} />
    </Routes>
  );
}
